import { Component, Input, OnInit } from '@angular/core';
import { Client, ClientOptionsMenuConfig } from '../../../../core/types/client';

@Component({
  selector: 'itfg-client-options-menu',
  templateUrl: './client-options-menu.component.html',
  styleUrls: ['./client-options-menu.component.scss'],
  standalone: false
})
export class ClientOptionsMenuComponent implements OnInit {
  @Input() clientId: number;
  @Input() client: Client;
  @Input() isInputClient: boolean;
  @Input()
  public config: ClientOptionsMenuConfig = new ClientOptionsMenuConfig();
  @Input() sendPasswordBySms: Function;
  @Input() sendPasswordByEmail: Function;
  @Input() openCreateOfferDialog: Function;
  @Input() openCreateCreditLimitOfferDialog: Function;
  @Input() data: any;
  @Input() isNewItem: boolean;

  constructor() { }

  ngOnInit() { 
  }

  onTempPassSmsClick() {
    this.sendPasswordBySms();
  }

  onTempPassEmailClick() {
    this.sendPasswordByEmail();
  }

  onOpenCreateOfferClick() {
    this.openCreateOfferDialog(this.client);
  }

  onOpenCreateCreditLimitOfferClick() {
    this.openCreateCreditLimitOfferDialog(this.client);
  }
}
